import React, { useEffect, useState } from "react";
import { Navigate, useLocation }       from "react-router-dom";
import { useUser } from "../context/UserContext";
import { ThreeDots } from "react-loader-spinner";

const ProtectedRoute = ({ children }) => {
  const { clientUser, workerUser, fetchLoggedInUser, loggedInUser } = useUser();
  const [isLoading, setIsLoading] = useState(true);
  const user = loggedInUser || clientUser || workerUser;

  const { pathname: fromPath } = useLocation();

  useEffect(() => {
    const checkUser = async () => {
      console.log("ProtectedRoute: Current user state:", {
        loggedInUser,
      });

      if (!user) {
        console.log(
          "ProtectedRoute: No user found, fetching logged-in user..."
        );
        try {
          const fetchedUser = await fetchLoggedInUser();
          console.log("ProtectedRoute: Fetched user:", fetchedUser);
        } catch (error) {
          console.error(
            "ProtectedRoute: Failed to fetch logged-in user:",
            error
          );
        }
      } else {
        console.log("ProtectedRoute: User already present:", user);
      }
      setIsLoading(false);
    };

    checkUser();
  }, [user, fetchLoggedInUser, clientUser, workerUser, loggedInUser]);

  if (isLoading) {
    return (
      <div className="loading-spinner">
        <ThreeDots
          visible={true}
          height="80"
          width="40"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </div>
    );
  }

  return user
    ? children
    : (
      <Navigate
        to="/login"
        state={{ from: fromPath }}
        replace
      />
    );
};

export default ProtectedRoute;
